import { Component } from '@angular/core';
import { NavController, NavParams, PopoverController, ToastController, AlertController } from 'ionic-angular';
import { DIC } from '../../../dic';
import { PopupPage } from '../../../popup/popup';
import { GN } from '../../../../gn';

/**
 * Generated class for the VehshiftsmodifyPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-vehshiftsmodify',
  templateUrl: 'vehshiftsmodify.html',
})
export class VehshiftsmodifyPage {
  gr: any;
  Title = ''
  startTime = '08:00'
  endTime = '16:00'
  _day = '1'
  _vehid = -1

  constructor(public navCtrl: NavController, public navParams: NavParams, public dic: DIC, public popoverCtrl: PopoverController, public gn: GN, public toastCtrl: ToastController, public alertCtrl: AlertController) {
    this.gr = navParams.get('gr')
    // console.log(this.gr.clientid)
    // console.log(this.gr)
    //debugger
    if (this.gr.id == -1) {
      this.Title = this.dic.l["newvehshift"]
    } else {
      this.Title = this.dic.l["editvehshift"]
      this._day = this.gr.dow
      this.startTime = this.gr.timefrom
      this.endTime = this.gr.timeto
    }
    this._vehid = this.gr.vehid
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad WorkshifteditPage');
  }

  openTimePopup(se, _ev) {
    var _that = this
    let popover = this.popoverCtrl.create(PopupPage, {
      type: 'timerec', selected: [], callback: function (_text, _ids) {
        if (se == 's') {
          _that.startTime = _text;
        }
        else {
          _that.endTime = _text;
        }
      }
    });
    popover.present({
      ev: _ev
    });
  }

  Save() {
    var _dat = {
      cid: this.gn.crypt(this.gn.user.ClientId),
      vehid: this.gn.crypt(this._vehid),
      dow: this.gn.crypt(this._day),
      timefrom: this.gn.crypt(this.startTime),
      timeto: this.gn.crypt(this.endTime),
      id: this.gn.crypt(this.gr.id),
    }
    var _that = this
    var check = 0;

    this.gn._Post('/api/gn/vehShift', _dat, function (_data) {
      var _cb = _that.navParams.get('cb')
      if (_cb != null) {
        _cb()
      }
      var _msg = _that.dic.l["succaddvehshift"]
      if (_that.gr.id + '' != '-1') {
        _msg = _that.dic.l["succedditvehshift"]
      }
      let toast = _that.toastCtrl.create({
        message: _msg,
        duration: 3000,
        position: 'top'
      });
      toast.present();
      _that.navCtrl.pop()
    })
  }
}



// WEBPACK FOOTER //
// ./src/pages/settings/editvehshifts/vehshiftsmodify/vehshiftsmodify.ts